module.exports = __webpack_public_path__ + "static/macbook-2-2efcde5694ff4927ba660900fcfd176a.jpg";